package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.feedback.Modal
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import co.maytes.standupbot.shared.roster.RosterSelection
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

@Composable
fun ImportChannelModal(
    workspaceId: String,
    channelId: String,
    channelName: String?,
    onConfirm: (slackUserIds: List<String>, includeGuests: Boolean) -> Unit,
    onDismiss: () -> Unit,
) {
    val rosterStore = rememberChannelRosterStore()
    val linearUsers = rememberLinearUsersStore()
    var selected by remember { mutableStateOf(emptySet<String>()) }
    val ready = rosterStore.state as? RosterPickerState.Ready
    val count = ready?.let { RosterSelection.counts(it.members, selected).selected } ?: 0
    val channelLabel = channelName?.let { "#$it" } ?: "the channel"

    Modal(
        onDismiss = onDismiss,
        title = "Add everyone in $channelLabel",
        widthPx = 600,
        footer = {
            SpanText(
                text = if (count == 0) "Nobody selected" else "$count selected",
                modifier = Modifier
                    .fontSize(Typography.bodySmall.size)
                    .color(Palette.textSecondary)
                    .styleModifier { property("flex", "1 1 auto") },
            )
            Button(label = "Cancel", variant = ButtonVariant.Ghost, onClick = onDismiss)
            Button(
                label = if (count == 0) "Add" else "Add $count",
                variant = ButtonVariant.Primary,
                enabled = ready != null && count > 0,
                onClick = {
                    ready?.let {
                        onConfirm(
                            RosterSelection.selectable(it.members).map { m -> m.slackUserId }.filter { id -> id in selected },
                            RosterSelection.includesGuests(it.members, selected),
                        )
                    }
                },
            )
        },
    ) {
        SpanText(
            text = "People already on the roster are shown but left alone. Guests start unchecked.",
            modifier = Modifier
                .fontSize(Typography.bodySmall.size)
                .color(Palette.textSecondary)
                .margin(bottom = Spacing.md),
        )
        ChannelRosterSection(
            store = rosterStore,
            workspaceId = workspaceId,
            channelId = channelId,
            channelName = channelName,
            selected = selected,
            onSelectionChange = { selected = it },
            linearUsers = linearUsers,
        )
    }
}
